<template>
    <v-form ref="form">
        <v-row>
            <v-col
                cols="12"
                md="3"
            > 
                <DatePicker
                    hide-details
                    outlined
                    dense
                    label="Date"
                    :rules="[isRequired]"
                    v-model="form.date"
                />
            </v-col>
            <v-col
                cols="12"
                md="3"
            >
                <DatePicker
                    hide-details
                    outlined
                    dense
                    label="Validity Date"
                    :rules="[isRequired]"
                    v-model="form.validity_date"
                />
            </v-col>
        </v-row>
        <v-row >
            <v-col cols="12" md="6" >
                <customer-search
                    hide
                    dense
                    outlined
                    hide-details="auto"
                    :label="$t('customer')"
                    item-text="display_name"
                    item-value="id"
                    @change="handleCustomerChange"
                    v-model="form.customer_id"
                    :rules="[isRequired]">
                </customer-search>
            </v-col>
            <v-col cols="12" md="4">
                <CustomerSitesSelect
                        hide-details="auto"
                        outlined
                        dense
                        label="Site"
                        :customerId="form.customer_id"
                        item-text='name'
                        item-value='id'
                        v-model="form.site_id"
                        :rules="[isRequired]"
                        
                    >
                    </CustomerSitesSelect>
            </v-col>
        </v-row >
        <v-row>
            <v-col>
                <QuotationLine v-for="(line,index) in form.lines" 
                    :key="line.key"
                    :index=index 
                    v-model="form.lines[index]"
                    @delete_line="handleLineDeleted(index)"
                    class="pt-1"
                    >
                </QuotationLine>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2">
                <v-btn small block @click="addLine" depressed>
                    <v-icon left >mdi-playlist-plus</v-icon>
                    add new Line
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-textarea
                outlined
                hide-details="auto"
                rows="4"
                :label="$t('note')"
                v-model="form.remarks">
            </v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import DatePicker from './../../components/common/DatePicker.vue'
import CustomerSearch from './../../components/searchComponents/CustomerSearch.vue'
import CustomerSitesSelect from './../../components/Sales/CustomerSitesSelect.vue'
import QuotationLine from './../../components/Sales/QuotationLine.vue'
import { isRequired, isNumeric } from './../../utils/validations'

export default {
    name: "QuotationForm",
    components: {
        DatePicker,
        CustomerSearch,
        CustomerSitesSelect,
        QuotationLine
    },
    props: {
        value: Object
    },
    data() {
        return {
            isRequired,
            isNumeric,
            form: {
                date: new Date().toISOString().substr(0, 10),
                validity_date: new Date().toISOString().substr(0, 10),
                customer_id: "",
                site_id: "",
                lines: [],
                remarks: ""
            },
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null,
                price: null,
                total: null
            },
            loading: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form, lines: [...form.lines]});
            }
        },
        
    },
    methods: {
        addLine() {
            this.form.lines.push({ ...this.line, key: Math.random() })
        },
        handleLineDeleted(index) {
            this.form.lines.splice(index, 1)
        },
        validate() {
            return this.$refs.form.validate()
        },
        handleCustomerChange() {
            this.form.site_id = null;
        }
    },
    created() {
        if(this.value) {
            this.form = {...this.value};
        }

    }
}
</script>

<style>

</style>
